
import { endpoints } from "../api"
import { setLoading, setSignupData } from "../../slices/AuthSlice";
import toast from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { setToken } from "../../slices/AuthSlice";
import { setUser }from '../../slices/ProfileSlice'
import {SetSignupData } from '../../slices/AuthSlice'
import {message} from '../../messages/Message'
import { setUrl } from "../../slices/urlSlice";

const {PROFILE_PICTURE_DELETE_API,PROFILE_API,UPDATE_PASSWORD_API,GET_USER_DETAILS_API,GET_PRICE_PER_USER,GET_SUBSCRIBE_DETAIL,SUBSCRIBE_PLAN,DASHBOARD_DATA} =endpoints




export function getUserDetails(token) {
    return async (dispatch) => {
        dispatch(setLoading(true));

        try {
            const response = await apiConnector("GET", GET_USER_DETAILS_API, "", {'Authorization': `Bearer ${token}` });


            if (response?.status === 200) {
                dispatch(setLoading(false));
                const userImage = response.data?.user?.profile_image
                    ? response.data.user.profile_image
                    : `https://api.dicebear.com/5.x/initials/svg?seed=${response.data.user.name} `
                dispatch(setUser({ ...response.data.user, profile_image: userImage }))
                dispatch(setUrl(response?.data?.url))
                if(response?.data?.url){
   localStorage.setItem("urlLink",JSON.stringify(response?.data?.url))
                }
             
                localStorage.setItem("user", JSON.stringify({...response?.data?.user,profile_image: userImage}))

            }
        } catch (error) {
            if (error?.response?.status === 401) {
                dispatch(setLoading(false))
            }
            else {
                dispatch(setLoading(false))
            }
        }
    }
}


export function uploadProfile(token, formData, onClose) {
    return async (dispatch) => {
        dispatch(setLoading(true));

        try {
            const response = await apiConnector("POST", PROFILE_API, formData, {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            });

            if (response?.status === 200) {
                dispatch(setLoading(false));
                onClose();
                dispatch(getUserDetails(token))
                toast.success(response.data.message)
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
            if (error?.response?.status === 403) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
            if (error?.response?.status === 500) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
          
        }
    }
}

export function deleteProfilePicture(token) {
    return async (dispatch) => {
        dispatch(setLoading(true));

        try {
            const response = await apiConnector("DELETE", PROFILE_PICTURE_DELETE_API, "", { 'Authorization': `Bearer ${token}` });


            if (response?.status === 200) {
                dispatch(setLoading(false))
                dispatch(getUserDetails(token))
                toast.success(response.data.message)
            }
        } catch (error) {
            if (error?.response?.status === 400) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
            if (error?.response?.status === 403) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
            if (error?.response?.status === 500) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
           
        }
    }

}

export function updatePassword(token, payload, onClose) {
    return async (dispatch) => {
        dispatch(setLoading(true));

        try {
            const response = await apiConnector("POST", UPDATE_PASSWORD_API, payload, { 'Authorization': `Bearer ${token}` });


            if (response?.status === 200) {
                dispatch(setLoading(false));
                onClose();
                toast.success(response.data.message)
            }
        } catch (error) {
            if (error?.response?.status === 422) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
            else if (error?.response?.status === 400) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
            else {
                dispatch(setLoading(false))
                toast.error(message.errorMessage)
            }
        }
    }

}



export function getPricePerUSer(token) {
    return async (dispatch) => {
        dispatch(setLoading(true));

        try {
            const response = await apiConnector("GET", GET_PRICE_PER_USER, "", { 'Authorization': `Bearer ${token}` });


            if (response?.status === 200) {
                dispatch(setLoading(false));
                return response;
            }
        } catch (error) {
            dispatch(setLoading(false))
            if (error?.response?.status === 422) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
            else if (error?.response?.status === 400) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
        }
    }

}



export function subscribePlan(token,payload) {
    return async (dispatch) => {
        dispatch(setLoading(true));

        try {
            const response = await apiConnector("POST", SUBSCRIBE_PLAN, payload, { 'Authorization': `Bearer ${token}` });
            
            if (response?.status === 201) {
                dispatch(setLoading(false));
                dispatch(getUserDetails(token));
                return response;
            }
        } catch (error) {
            dispatch(setLoading(false))
            if (error?.response?.status === 422) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
            else if (error?.response?.status === 400) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
        }
    }

}


export function subscribeDetail(token) {
    return async (dispatch) => {
        dispatch(setLoading(true));

        try {
            const response = await apiConnector("GET", GET_SUBSCRIBE_DETAIL, "", { 'Authorization': `Bearer ${token}` });
            
            if (response?.status === 200) {
                dispatch(setLoading(false));
                dispatch(getUserDetails(token));
                return response;
            }
        } catch (error) {
            dispatch(setLoading(false))
            if (error?.response?.status === 422) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
            else if (error?.response?.status === 400) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
        }
    }

}


export function getDashboardData(token,filter) {
    return async (dispatch) => {
        dispatch(setLoading(true));

        try {
            const response = await apiConnector("GET", DASHBOARD_DATA, "", { 'Authorization': `Bearer ${token}` },{filters:`${filter}`});


            if (response?.status === 200) {
                dispatch(setLoading(false));
                return response;
            }
        } catch (error) {
            dispatch(setLoading(false))
            if (error?.response?.status === 422) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
            else if (error?.response?.status === 400) {
                dispatch(setLoading(false))
                toast.error(error.response.data.message)
            }
        }
    }

}
